export enum Step {
  Join = 'join',
  Confirmation = 'confirmation',
  ConfirmationWithPassword = 'confirmation_with_password',
}
